import { TabPanel } from "@headlessui/react";
import { type ReactNode } from "react";

export const NavigationTabPanel = ({ children }: { children: ReactNode }) => {
  return <TabPanel>{children}</TabPanel>;
};
